import React, { useEffect, useState } from 'react';
import { HiQuestionMarkCircle } from "react-icons/hi2";

import { getFaqsForPublic } from '../../services/Faq';
import { Helmet } from 'react-helmet-async';

function AllFaq() {
    const [faqData, setFaqData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        let timeoutId: ReturnType<typeof setTimeout>;

        const pollFaqs = async () => {
            try {
                const response = await getFaqsForPublic();

                // If your getFaqs() returns only the data on success
                if (isMounted) {
                    setFaqData(response);
                    setLoading(false);
                }

                // Stop polling after success
                return;
            } catch (error) {
                console.error("Failed to fetch FAQs. Retrying...", error);

                // Retry after 3 seconds
                if (isMounted) {
                    timeoutId = setTimeout(pollFaqs, 3000);
                }
            }
        };

        pollFaqs();

        return () => {
            isMounted = false;
            clearTimeout(timeoutId);
        };
    }, []);

    return (
        <>
            <div className="bg-slate-50">
                <Helmet>
                    <title>My Church Directory Faq | Online Church Directory Software</title>

                    <meta
                        name="description"
                        content="Explore powerful church directory features including member management, mobile apps, email and text messaging, printable directories, and secure online access. Manage your church directory with ease."
                    />
                </Helmet>



                {/* FAQs */}
                <section className="py-20">
                    <div className="max-w-4xl mx-auto px-6">

                        <div className="text-center mb-14">
                            <h2 className="different_heading text-3xl font-bold">
                                Frequently Asked Questions
                            </h2>

                            <p className="mt-3 text-slate-600">
                                Everything you need to know before getting started.
                            </p>
                        </div>

                        {
                            loading && (
                                <div className="min-h-screen flex items-center justify-center">
                                    <div className="flex flex-col items-center gap-4">
                                        <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-secondary" />
                                        <p className="text-gray-600">Loading FAQs...</p>
                                    </div>
                                </div>
                            )
                        }

                        {
                            !loading && faqData.length > 0 && (
                                <div className="space-y-5">

                                    {faqData.map((item) => (
                                        <details
                                            key={item.id}
                                            className="group rounded-2xl border border-slate-200 bg-white shadow-sm"
                                        >
                                            <summary className="flex cursor-pointer items-center justify-between p-6 list-none">
                                                <div className="flex items-center gap-4">
                                                    <HiQuestionMarkCircle className="text-secondary text-2xl flex-shrink-0" />

                                                    <h3 className="text-lg font-semibold text-slate-900">
                                                        {item.question}
                                                    </h3>
                                                </div>

                                                <span className="text-2xl text-slate-400 group-open:rotate-45 transition">
                                                    +
                                                </span>
                                            </summary>

                                            <div className="px-6 pb-6 pl-16 text-slate-600 leading-7">
                                                {item.answer}
                                            </div>
                                        </details>
                                    ))}

                                </div>
                            )
                        }

                        {
                            loading && faqData.length === 0 && (
                                <div className="min-h-screen flex items-center justify-center">
                                    <div className="flex flex-col items-center gap-4">
                                        <p className="text-gray-600">No data found</p>
                                    </div>
                                </div>
                            )
                        }

                    </div>
                </section>

            </div>
        </>
    );
}

export default AllFaq;
